
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as cartn0UftVfIVIcLbUVzInD98qfoOtXxLUtIYx27Jf3ha_0Meta } from "/opt/buildhome/repo/app/pages/cart.vue?macro=true";
import { default as indexBUquJ6FW9selPoMmXmiQ06xberjjtjDDexnQK6NGwH0Meta } from "/opt/buildhome/repo/app/pages/index.vue?macro=true";
import { default as loginGl0mRqaq_Lxq2m4Ffurs3Awcsqo0YQUvhoY_AZvpXl4Meta } from "/opt/buildhome/repo/app/pages/login.vue?macro=true";
import { default as about_45abcjTkiypG1EpiGmVqtzNUMMXUpsGm5Z5k1RThkv6QUpbwMeta } from "/opt/buildhome/repo/app/pages/about-abc.vue?macro=true";
import { default as indexwswRlPUtTS6B4OwTqkAl0CPPJxbU9WPG92DJgLqCAqcMeta } from "/opt/buildhome/repo/app/pages/home/index.vue?macro=true";
import { default as _91state_93cwcNN9l5ArdyawqcW3vvo5xJ88rhXeK41qu_TmrTR8gMeta } from "/opt/buildhome/repo/app/pages/home/[state].vue?macro=true";
import { default as how_45to_45order7UmsmLO4YTZdqB0mMBTmTpEW08cB3ysEunhmDr4R9TsMeta } from "/opt/buildhome/repo/app/pages/how-to-order.vue?macro=true";
import { default as terms_45of_45usebx2w9XpPD4PB1aWgcTltbyTL8nq0FnsdItt7DO7ZbAkMeta } from "/opt/buildhome/repo/app/pages/terms-of-use.vue?macro=true";
import { default as accessibilitypklK0Exx3qV0QTUgfQFTrogXUYBaRi38J_KeVHgOl_gMeta } from "/opt/buildhome/repo/app/pages/accessibility.vue?macro=true";
import { default as indexwGnz2yQx_nTTSO1Ma5F9aQuXdGJ7UjYqS2On4Rc4EhMMeta } from "/opt/buildhome/repo/app/pages/account/index.vue?macro=true";
import { default as indexkRBNGIIJGefesu79IecwXOyHgtz5tZXkNo1MWviaV0sMeta } from "/opt/buildhome/repo/app/pages/careers/index.vue?macro=true";
import { default as indexOlJogh_A2vkl9HcIiAZErLm9lRkAJ3esNO2sSjzdkFMMeta } from "/opt/buildhome/repo/app/pages/catalog/index.vue?macro=true";
import { default as indexsQPDkbbEcGstKW8BAJMTLOanxhCs9KQ42_H4DUdCbTMMeta } from "/opt/buildhome/repo/app/pages/podcast/index.vue?macro=true";
import { default as indexRjEAGMQusQ17hhmUQeM_sLpQy_6kerN3HhMgOsZqywsMeta } from "/opt/buildhome/repo/app/pages/articles/index.vue?macro=true";
import { default as indexMvHCxt7rXF92Ek8D7up3SPFQKjItIRnMwlXMZnGmnXoMeta } from "/opt/buildhome/repo/app/pages/checkout/index.vue?macro=true";
import { default as create_45accountakqtQG2yFIGUDtJzL4SK0TONlVHio6wZBhLExixCR2MMeta } from "/opt/buildhome/repo/app/pages/create-account.vue?macro=true";
import { default as privacy_45policyasrCwkRdnyvAGXXuQsFWMTp0EZOC0BOYbdwh2ly8hR8Meta } from "/opt/buildhome/repo/app/pages/privacy-policy.vue?macro=true";
import { default as indexjM5WBYpwSNXo10ANlMlveaGc_T9oBskvKJDM4_TnPjgMeta } from "/opt/buildhome/repo/app/pages/products/index.vue?macro=true";
import { default as reset_45passwordM9KP59MP5zfJuGzxFbrRnSJPjJ4Ofz1sYT9607VpLzUMeta } from "/opt/buildhome/repo/app/pages/reset-password.vue?macro=true";
import { default as share_45wishlistW8f5uF_MvKQOEqtvSWkAHsiqBExQ_VD6Td5yJA_pXQ8Meta } from "/opt/buildhome/repo/app/pages/share-wishlist.vue?macro=true";
import { default as details_hUSCLwitHF4MpupsWHBxO3Vt6XoNlOHMfYZDXNz4AwMeta } from "/opt/buildhome/repo/app/pages/account/details.vue?macro=true";
import { default as _91state_934jrN6RV4d_GP_Mixb00qm2WEyjLSzcSe8VZVkIOVj68Meta } from "/opt/buildhome/repo/app/pages/catalog/[state].vue?macro=true";
import { default as forgot_45passwordx7ltq_adgcZxq_3I5xxOKO67_gQQ1dalvzECVeoFSPUMeta } from "/opt/buildhome/repo/app/pages/forgot-password.vue?macro=true";
import { default as _91career_93e56sVIILn8yEj_aSANMuAypUyNOXG5uw026EWc7yDvEMeta } from "/opt/buildhome/repo/app/pages/careers/[career].vue?macro=true";
import { default as my_45orders4YjVxJvx8B23NNLeJ24H_VS6T8ZGzGXXnPmSoVPi7kMMeta } from "/opt/buildhome/repo/app/pages/account/my-orders.vue?macro=true";
import { default as _91article_93YXEBUo8hzusxSa0dZDgHBsmHivC_Ry8UOXd7VFatuccMeta } from "/opt/buildhome/repo/app/pages/articles/[article].vue?macro=true";
import { default as _91_46_46_46slug_93D5Jo504_KOXwIvHWTbT1f603VU8NOrJ9cemYnszuNxwMeta } from "/opt/buildhome/repo/app/pages/products/[...slug].vue?macro=true";
import { default as test_45auto_45completeBmkYU0klbqxupoiR5VA70bdOF_mugJTmyQuhow0szVAMeta } from "/opt/buildhome/repo/app/pages/test-auto-complete.vue?macro=true";
import { default as my_45wishlistj5cfg4PsJopFiirCO4Jin6ITmPlxD9G9Nn291aHmRNgMeta } from "/opt/buildhome/repo/app/pages/account/my-wishlist.vue?macro=true";
import { default as submit_45a_45pob689R0EnAiPMl3xbttq_h0_NFZAzPbWbH1UH0D04a8EMeta } from "/opt/buildhome/repo/app/pages/account/submit-a-po.vue?macro=true";
import { default as _91page_93PWD3yDh5jsZJGCNUMri4aeRFO39hK_Rz3V9HNgJgdWkMeta } from "/opt/buildhome/repo/app/pages/articles/page/[page].vue?macro=true";
import { default as _91step_93e7Lwpownn5Ejr15mKbq6cxGTtiFvAJoaMLVioJS0pRMMeta } from "/opt/buildhome/repo/app/pages/checkout/step/[step].vue?macro=true";
import { default as _91_46_46_46slug_93CwYRGJtUUy_RgxQLzEBMHcw2u3Oxp58gheAYscaxIu0Meta } from "/opt/buildhome/repo/app/pages/free-trial/[...slug].vue?macro=true";
import { default as thank_45youoZTglBQld0DovlQs4ViY3pEsmz2w76NQg64oFDYpUhQMeta } from "/opt/buildhome/repo/app/pages/free-trial/thank-you.vue?macro=true";
import { default as confirmation383ck79OIzJCdrsB15vVKvW17r_wR_qZmxMU9nGGcL4Meta } from "/opt/buildhome/repo/app/pages/checkout/confirmation.vue?macro=true";
import { default as documents_45for_45orderingbKoo39_y1eCBw6SeffkCV2P1O21C90vpOEEi49_sHmEMeta } from "/opt/buildhome/repo/app/pages/documents-for-ordering.vue?macro=true";
import { default as indexblhqOozeAaEiApFWHCvb_r8G_6dZqENQ9dwjmAHzimUMeta } from "/opt/buildhome/repo/app/pages/products/[product]/index.vue?macro=true";
import { default as add_45payment_45methodos_JMzVM2jwKgqpep_AAwIJiQK0GXcQplSEgWAPB3usMeta } from "/opt/buildhome/repo/app/pages/account/add-payment-method.vue?macro=true";
import { default as component_45stubbdf2p5qUScra2aRfyhuhSQvCP2QT1lMfD0xuAqHPTxQMeta } from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@4.0.3_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.2.0_@vue+compiler-_040602a2a7b55983547483683808f207/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubbdf2p5qUScra2aRfyhuhSQvCP2QT1lMfD0xuAqHPTxQ } from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@4.0.3_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.2.0_@vue+compiler-_040602a2a7b55983547483683808f207/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "cart",
    path: "/cart",
    component: () => import("/opt/buildhome/repo/app/pages/cart.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexBUquJ6FW9selPoMmXmiQ06xberjjtjDDexnQK6NGwH0Meta || {},
    component: () => import("/opt/buildhome/repo/app/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: { ...(loginGl0mRqaq_Lxq2m4Ffurs3Awcsqo0YQUvhoY_AZvpXl4Meta || {}), ...{"middleware":"guest"} },
    component: () => import("/opt/buildhome/repo/app/pages/login.vue")
  },
  {
    name: "about-abc",
    path: "/about-abc",
    component: () => import("/opt/buildhome/repo/app/pages/about-abc.vue")
  },
  {
    name: "home",
    path: "/home",
    meta: indexwswRlPUtTS6B4OwTqkAl0CPPJxbU9WPG92DJgLqCAqcMeta || {},
    component: () => import("/opt/buildhome/repo/app/pages/home/index.vue")
  },
  {
    name: "home-state",
    path: "/home/:state()",
    meta: _91state_93cwcNN9l5ArdyawqcW3vvo5xJ88rhXeK41qu_TmrTR8gMeta || {},
    component: () => import("/opt/buildhome/repo/app/pages/home/[state].vue")
  },
  {
    name: "how-to-order",
    path: "/how-to-order",
    meta: how_45to_45order7UmsmLO4YTZdqB0mMBTmTpEW08cB3ysEunhmDr4R9TsMeta || {},
    component: () => import("/opt/buildhome/repo/app/pages/how-to-order.vue")
  },
  {
    name: "terms-of-use",
    path: "/terms-of-use",
    component: () => import("/opt/buildhome/repo/app/pages/terms-of-use.vue")
  },
  {
    name: "accessibility",
    path: "/accessibility",
    component: () => import("/opt/buildhome/repo/app/pages/accessibility.vue")
  },
  {
    name: "account",
    path: "/account",
    component: () => import("/opt/buildhome/repo/app/pages/account/index.vue")
  },
  {
    name: "careers",
    path: "/careers",
    meta: indexkRBNGIIJGefesu79IecwXOyHgtz5tZXkNo1MWviaV0sMeta || {},
    component: () => import("/opt/buildhome/repo/app/pages/careers/index.vue")
  },
  {
    name: "catalog",
    path: "/catalog",
    component: () => import("/opt/buildhome/repo/app/pages/catalog/index.vue")
  },
  {
    name: "podcast",
    path: "/podcast",
    meta: indexsQPDkbbEcGstKW8BAJMTLOanxhCs9KQ42_H4DUdCbTMMeta || {},
    component: () => import("/opt/buildhome/repo/app/pages/podcast/index.vue")
  },
  {
    name: "articles",
    path: "/articles",
    meta: indexRjEAGMQusQ17hhmUQeM_sLpQy_6kerN3HhMgOsZqywsMeta || {},
    component: () => import("/opt/buildhome/repo/app/pages/articles/index.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    component: () => import("/opt/buildhome/repo/app/pages/checkout/index.vue")
  },
  {
    name: "create-account",
    path: "/create-account",
    meta: {"middleware":"guest"},
    component: () => import("/opt/buildhome/repo/app/pages/create-account.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/opt/buildhome/repo/app/pages/privacy-policy.vue")
  },
  {
    name: "products",
    path: "/products",
    component: () => import("/opt/buildhome/repo/app/pages/products/index.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: {"middleware":"guest"},
    component: () => import("/opt/buildhome/repo/app/pages/reset-password.vue")
  },
  {
    name: "share-wishlist",
    path: "/share-wishlist",
    component: () => import("/opt/buildhome/repo/app/pages/share-wishlist.vue")
  },
  {
    name: "account-details",
    path: "/account/details",
    component: () => import("/opt/buildhome/repo/app/pages/account/details.vue")
  },
  {
    name: "catalog-state",
    path: "/catalog/:state()",
    component: () => import("/opt/buildhome/repo/app/pages/catalog/[state].vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: {"middleware":"guest"},
    component: () => import("/opt/buildhome/repo/app/pages/forgot-password.vue")
  },
  {
    name: "careers-career",
    path: "/careers/:career()",
    meta: _91career_93e56sVIILn8yEj_aSANMuAypUyNOXG5uw026EWc7yDvEMeta || {},
    component: () => import("/opt/buildhome/repo/app/pages/careers/[career].vue")
  },
  {
    name: "account-my-orders",
    path: "/account/my-orders",
    component: () => import("/opt/buildhome/repo/app/pages/account/my-orders.vue")
  },
  {
    name: "articles-article",
    path: "/articles/:article()",
    component: () => import("/opt/buildhome/repo/app/pages/articles/[article].vue")
  },
  {
    name: "products-slug",
    path: "/products/:slug(.*)*",
    component: () => import("/opt/buildhome/repo/app/pages/products/[...slug].vue")
  },
  {
    name: "test-auto-complete",
    path: "/test-auto-complete",
    component: () => import("/opt/buildhome/repo/app/pages/test-auto-complete.vue")
  },
  {
    name: "account-my-wishlist",
    path: "/account/my-wishlist",
    component: () => import("/opt/buildhome/repo/app/pages/account/my-wishlist.vue")
  },
  {
    name: "account-submit-a-po",
    path: "/account/submit-a-po",
    component: () => import("/opt/buildhome/repo/app/pages/account/submit-a-po.vue")
  },
  {
    name: "articles-page-page",
    path: "/articles/page/:page()",
    meta: _91page_93PWD3yDh5jsZJGCNUMri4aeRFO39hK_Rz3V9HNgJgdWkMeta || {},
    component: () => import("/opt/buildhome/repo/app/pages/articles/page/[page].vue")
  },
  {
    name: "checkout-step-step",
    path: "/checkout/step/:step()",
    component: () => import("/opt/buildhome/repo/app/pages/checkout/step/[step].vue")
  },
  {
    name: "free-trial-slug",
    path: "/free-trial/:slug(.*)*",
    component: () => import("/opt/buildhome/repo/app/pages/free-trial/[...slug].vue")
  },
  {
    name: "free-trial-thank-you",
    path: "/free-trial/thank-you",
    component: () => import("/opt/buildhome/repo/app/pages/free-trial/thank-you.vue")
  },
  {
    name: "checkout-confirmation",
    path: "/checkout/confirmation",
    component: () => import("/opt/buildhome/repo/app/pages/checkout/confirmation.vue")
  },
  {
    name: "documents-for-ordering",
    path: "/documents-for-ordering",
    component: () => import("/opt/buildhome/repo/app/pages/documents-for-ordering.vue")
  },
  {
    name: "products-product",
    path: "/products/:product()",
    component: () => import("/opt/buildhome/repo/app/pages/products/[product]/index.vue")
  },
  {
    name: "account-add-payment-method",
    path: "/account/add-payment-method",
    component: () => import("/opt/buildhome/repo/app/pages/account/add-payment-method.vue")
  },
  {
    name: component_45stubbdf2p5qUScra2aRfyhuhSQvCP2QT1lMfD0xuAqHPTxQMeta?.name,
    path: "/account/",
    component: component_45stubbdf2p5qUScra2aRfyhuhSQvCP2QT1lMfD0xuAqHPTxQ
  }
]